import { useState } from 'react';
import { FileUploadMediaResponse } from '@api/models/invitation/FileUploadMediaResponse';

export function useFileUploadQueue(onBatchComplete: (ids: string[]) => Promise<void>) {
  const [fileQueue, setFileQueue] = useState<File[]>([]);
  const [uploadedIds, setUploadedIds] = useState<string[]>([]);
  const currentFile = fileQueue.length > 0 ? fileQueue[0] : null;

  const handleFiles = (files: File[]) => {
    setFileQueue((prev) => [...prev, ...files]);
  };

  const handleFileUploaded = async (document: FileUploadMediaResponse) => {
    if (!currentFile) return;
    const nextQueue = fileQueue.slice(1);
    const newIds = [...uploadedIds, document.id!];
    if (nextQueue.length === 0) {
      await onBatchComplete(newIds);
      setUploadedIds([]);
    } else {
      setUploadedIds(newIds);
    }
    setFileQueue(nextQueue);
  };

  const handleFileCancel = async () => {
    const nextQueue = fileQueue.slice(1);
    if (nextQueue.length === 0 && uploadedIds.length > 0) {
      await onBatchComplete(uploadedIds);
      setUploadedIds([]);
    }
    setFileQueue(nextQueue);
  };

  return { currentFile, handleFiles, handleFileUploaded, handleFileCancel };
}
